import { useAppSelector } from '../../store/hooks'

export const useVersion = () => {
  const version = useAppSelector((state) => state.version)
  return version
}
